import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "swiper/css";

const initHomeBlogSliders = () => {
    document.querySelectorAll('[data-home-blog-slider]').forEach((root) => {
        const slides = root.querySelectorAll('.swiper-slide');
        const section = root.closest('.blog-section');
        const prevBtns = section ? Array.from(section.querySelectorAll('.home-blog-navigation .prev, .ctrl-list__item.prev')) : [];
        const nextBtns = section ? Array.from(section.querySelectorAll('.home-blog-navigation .next, .ctrl-list__item.next')) : [];

        if (slides.length < 2) {
            section?.querySelectorAll('.home-blog-navigation, .blog-section__mobile-nav')?.forEach(el => el.setAttribute('hidden', 'hidden'));
            return;
        }

        const swiper = new Swiper(root, {
            modules: [A11y],
            slidesPerView: 1.08,
            spaceBetween: 16,
            speed: 420,
            watchOverflow: true,
            a11y: {
                prevSlideMessage: 'Previous article',
                nextSlideMessage: 'Next article',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 28,
                },
            },
        });

        const updateNavButtons = () => {
            const isBeginning = swiper.isBeginning;
            const isEnd = swiper.isEnd;

            prevBtns.forEach((btn) => {
                btn.classList.toggle('swiper-button-disabled', isBeginning);
                btn.classList.toggle('disabled', isBeginning);
                btn.setAttribute('aria-disabled', isBeginning ? 'true' : 'false');
            });

            nextBtns.forEach((btn) => {
                btn.classList.toggle('swiper-button-disabled', isEnd);
                btn.classList.toggle('disabled', isEnd);
                btn.setAttribute('aria-disabled', isEnd ? 'true' : 'false');
            });
        };

        prevBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                swiper.slidePrev();
            });
        });

        nextBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                swiper.slideNext();
            });
        });

        swiper.on('init', updateNavButtons);
        swiper.on('slideChange', updateNavButtons);
        swiper.on('toEdge', updateNavButtons);
        swiper.on('fromEdge', updateNavButtons);
        swiper.on('resize', updateNavButtons);
        updateNavButtons();
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeBlogSliders, { once: true });
} else {
    initHomeBlogSliders();
}
